export interface DropoffLocation {
  lat: string;
  lng: string;
}

export enum DeliveryStatus {
  NEW = 'new',
  PLACED = 'placed',
  ARRIVED = 'arrived',
  ENROUTE = 'enroute',
  DELIVERED = 'delivered',
  CANCELLED = 'cancelled',
}

export enum OrderStatusType {
  ACTIVE = 'active',
  HISTORY = 'history',
  CANCELLED = 'cancelled',
}

export const statusMapDoorDashOrders: Record<OrderStatusType, DeliveryStatus[]> = {
  [OrderStatusType.ACTIVE]: [DeliveryStatus.NEW, DeliveryStatus.PLACED, DeliveryStatus.ARRIVED, DeliveryStatus.ENROUTE],
  [OrderStatusType.HISTORY]: [DeliveryStatus.DELIVERED],
  [OrderStatusType.CANCELLED]: [DeliveryStatus.CANCELLED],
};

export interface DeliveryInfo {
  order_id: string;
  store_id: string;
  accepted_at: string | null;
  canceled_at: string | null;
  delivery_at: string | null;
  devliery_id: number;
  tracking_url: string;
  delivery_status: DeliveryStatus;
  scheduled_order: boolean;
  delivery_order_id: string;
  cancellation_reason: string | null;
}

export interface Customer {
  full_name: string | null;
  last_name: string | null;
  first_name: string | null;
  phone_number: string | null;
}
export interface CourierInfo {
  id: number;
  name: string;
  photo_url: string;
  phone_code: string;
  phone_number: string;
  vehicle_type: string;
}

export interface OrderCharges {
  total: number;
  subtotal: number;
  delivery_fee: number;
  delivery_tips: number;
}

export interface PickupInfo {
  store_name: string;
  pickup_notes: string | null;
  store_address: string;
  pickup_datetime: string;
  estimated_pickup_at: string | null;
}

export interface DropOffInfo {
  drop_off_notes: string;
  drop_off_address: string;
  drop_off_datetime: string | null;
  estimated_dropoff_at: string | null;
}
